
import * as actionTypes from './actionTypes';

export const resetUpnpState = () => {
  return {
    type: actionTypes.RESET_UPNP_STATE,
    
  };
}
export const initUpnpStart = () => {
  return {
    type: actionTypes.INIT_UPNP_START
  };
};
export const refreshUpnp = () => {
  return window.location.reload();
};
export const setUpnp = (realUpnp) => {
  return {
    type: actionTypes.SET_UPNP,
    realUpnp:realUpnp
  };
};

export const fetchUpnpFailed = () => {
  return {
    type: actionTypes.FETCH_UPNP_FAILED
  };
};

export const initUpnp = () => {
  return {
    type: actionTypes.INIT_UPNP
  };
};
export const changeUpnp = (enabled) => {
  return {
    type: actionTypes.CHANGE_UPNP,
    enabled:enabled
  };
}
export const changeUpnpFailed = () => {
  return {
    type: actionTypes.CHANGE_UPNP_FAILED
  }
}
export const changeUpnpSuccess = () => {
  return {
    type: actionTypes.CHANGE_UPNP_SUCCESS
  }
}
export const resetUpnpErrorSuccess = () => {

  return {
    type: actionTypes.RESET_UPNP_ERROR_SUCCESS
  }
}


